const createActionType = (namespace, type) => `${namespace}/${type}`

export default (namespace, types = []) => types.reduce((acc, type) => ({
  ...acc,
  [type]: createActionType(namespace, type),
}), {})
